import React from "react";

import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";
import Stack from "@mui/material/Stack";
import { CopyButton } from "@src/features/experienceBuilder/modifications/common/CopyButton";
import { useSelector } from "@src/store";
import { ExperienceBuilderSelector } from "@src/store/slices/experienceBuilder";

interface GroupVariationRowProps {
  variationName: string;
  valueSummary: string;
  mod: EmbeddedMod;
}

export const GroupVariationRow = ({
  variationName,
  valueSummary,
  mod,
}: GroupVariationRowProps) => {
  const currentVariationId = useSelector(
    ExperienceBuilderSelector.getVariationId
  );

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ px: 3, py: 2 }}
    >
      <Stack>
        <IgTypography variant="body1" fontWeight={600}>
          {variationName}
        </IgTypography>
        <IgTypography variant="body2" color="text.secondary" noWrap>
          {valueSummary}
        </IgTypography>
      </Stack>
      <CopyButton mod={mod} targetVariationId={currentVariationId} />
    </Stack>
  );
};
